import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ModalModel } from "../../models/modalModel";

const initialModalState: ModalModel = {
  loginVisible: false,
  leavePageVisible: false,
  paymentStatusVisible: false,
  forgotPasswordVisible: false,
  notPayableVisible: false,
  idMatchVisible: false,
  areYouSureVisible: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState: initialModalState,
  reducers: {
    setLoginVisible(state, action: PayloadAction<boolean>) {
      state.loginVisible = action.payload;
    },
    setLeavePageVisible(state, action: PayloadAction<boolean>) {
      state.leavePageVisible = action.payload;
    },
    setPaymentStatusVisible(state, action: PayloadAction<boolean>) {
      state.paymentStatusVisible = action.payload;
    },
    setForgotPasswordVisible(state, action: PayloadAction<boolean>) {
      state.forgotPasswordVisible = action.payload;
    },
    setNotPayableVisible(state, action: PayloadAction<boolean>) {
      state.notPayableVisible = action.payload;
    },
    setIDMatchVisible(state, action: PayloadAction<boolean>) {
      state.idMatchVisible = action.payload;
    },
    setAreYouSureVisible(state, action: PayloadAction<boolean>) {
      state.areYouSureVisible = action.payload;
    },
  },
});
export default modalSlice;
